import PropTypes from 'prop-types';
import App from 'modules/App';
export const authorizationCode = PropTypes.shape({
    code: PropTypes.string,
    storageProvider: PropTypes.oneOf(App.constants.CLOUD_DRIVES)
});
